import React from "react";
import { FaChartBar, FaChartLine, FaDownload } from "react-icons/fa";
import { RiResetLeftLine } from "react-icons/ri";

const ChartToolbar = ({
  limit,
  onLimitChange,
  onTop10,
  onTop20,
  onShowAll,
  onSortHighest,
  onSortLowest,
  onClear,
  onDownload,
  onChartType,
  valuesEnabled,
  onToggleValues,
  setShowValues,
}) => {
  return (
    <div className="d-flex align-items-center gap-2">
      {/* ---- DOWNLOAD ---- */}
      <button className="btn btn-sm btn-outline-light" onClick={onDownload}>
        <FaDownload />
      </button>

      {/* ---- BAR ---- */}
      <button
        className="btn btn-sm btn-outline-light"
        onClick={() => onChartType("bar")}
      >
        <FaChartBar />
      </button>

      {/* ---- LINE ---- */}
      <button
        className="btn btn-sm btn-outline-light"
        onClick={() => onChartType("line")}
      >
        <FaChartLine />
      </button>

      {/* ---- RESET ---- */}
      <button
        className="btn btn-sm btn-outline-light"
        onClick={() => onChartType("reset")}
      >
        <RiResetLeftLine />
      </button>

      {/* ---- LIMIT INPUT ---- */}
      <input
        type="number"
        value={limit}
        onChange={(e) => {
          const v = e.target.value;
          if (v === "") {
            onLimitChange("");
          } else {
            onLimitChange(Number(v));
          }
        }}
        onBlur={() => {
          if (limit === "" || limit < 1) onLimitChange(1);
        }}
        className="form-control form-control-sm"
        style={{ width: 60 }}
      />

      {/* ---- QUICK LIMITS ---- */}
      <button className="btn btn-sm btn-outline-light" onClick={onTop10}>
        Top 10
      </button>

      <button className="btn btn-sm btn-outline-light" onClick={onTop20}>
        Top 20
      </button>

      <button className="btn btn-sm btn-outline-light" onClick={onShowAll}>
        All
      </button>

      {/* ---- SORT ---- */}
      <button className="btn btn-sm btn-outline-light" onClick={onSortHighest}>
        Highest
      </button>

      <button className="btn btn-sm btn-outline-light" onClick={onSortLowest}>
        Lowest
      </button>
      <button
        className={`toolbar-btn ${valuesEnabled ? "active" : ""}`}
        onClick={onToggleValues}
      >
        🔢 Values
      </button>

      {/* ---- CLEAR MENU ---- */}
      <select
        className="form-select form-select-sm"
        onChange={(e) => onClear(e.target.value)}
      >
        <option value="">Clear ▼</option>
        <option value="limit">Clear Limit</option>
        <option value="all">Clear All</option>
      </select>
    </div>
  );
};

export default ChartToolbar;
